import { HttpClient, HttpBackend } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

export interface AuthResponse {
    accessToken: string;
    refreshToken: string;
    expiresAt: string;
}

@Injectable({ providedIn: 'root' })
export class AuthClient {
    private baseUrl: string;
    private httpClient: HttpClient;

    constructor(private httpBackend: HttpBackend) {
        this.baseUrl = `${environment.baseUrl}/api`;
        // Create HttpClient that bypasses all interceptors
        this.httpClient = new HttpClient(httpBackend);
    }

    register(email: string, password: string, companyType: number, companyName?: string): Observable<AuthResponse> {
        const body: any = { 
            email, 
            password, 
            companyType 
        };
        if (companyName) {
            body.companyName = companyName;
        }
        return this.httpClient.post<AuthResponse>(`${this.baseUrl}/auth/register`, body, {
            headers: {
                'Content-Type': 'application/json',
                "Ocp-Apim-Subscription-Key": environment.subscriptionKey,
            }
        });
    }

    login(email: string, password: string): Observable<AuthResponse> {
        return this.httpClient.post<AuthResponse>(`${this.baseUrl}/auth/login`, { email, password }, {
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': environment.subscriptionKey,
            }
        });
    }

    refreshTokens(refreshToken: string): Observable<AuthResponse> {
        return this.httpClient.post<AuthResponse>(`${this.baseUrl}/auth/refresh`, { refreshToken }, {
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': environment.subscriptionKey,
            }
        });
    }
    
    logout(refreshToken: string): Observable<void> {
        return this.httpClient.post<void>(`${this.baseUrl}/auth/revoke`, {refreshToken}, {
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': environment.subscriptionKey,
            }
        });
    }

    exchangeAzureToken(azureToken: string): Observable<AuthResponse> {
        return this.httpClient.get<AuthResponse>(`${this.baseUrl}/external-auth/exchange`, {
            headers: {
                'Authorization': `Bearer ${azureToken}`,
            }
        });
    }
}